import { useTranslation } from 'react-i18next'
import Button from 'ui/Button'
import { getThumbnail } from 'utils/thumbnails'
import { Container, Cover, Header, Title } from './styles'


const NextEpisode = ({ episode, onPlay }) => {

  const { t } = useTranslation()

  return (
    <Container>

      <Cover>
        <img src={getThumbnail(episode)} alt='' />
      </Cover>
      <div>
        <div>
          <Header>{t('continueWatching')}</Header>
          <Title>{t('episode')} {episode.order + 1} | {episode.title}</Title>
        </div>

        <Button isFull onClick={onPlay}>
          {t('watchNow')}
        </Button>
      </div>
    </Container>
  )
}

export default NextEpisode